import { LoadSpinner } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import { useDebounce } from '@shared/hooks'
import React, { ChangeEvent, useState } from 'react'

import { Dropdown } from '@/components'
import { useTicketFiltersContext } from '@/context/filters/ticketFilters/ticketFilters'
import { UserQueries } from '@/graphql/queries/user.queries'
import { useGraphql } from '@/hooks/useGraphql'

type userOptions = {
  fullName?: string
  id: number
}

export const OwnerFilter = () => {
  const { setFilters, ticketAssigneeId } = useTicketFiltersContext()
  const [dropdownExpanded, setDropdownExpanded] = useState(false)
  const [searchString, setSearchString] = useState<string>()
  const debouncedSearch = useDebounce(searchString, 1000)
  const { data, isLoading } = useGraphql<{ authorizedUsers: userOptions[] }>(
    UserQueries.QUERY_KEYS.getSearchOwner,
    UserQueries.getSearchOwner(),
    {
      searchString: debouncedSearch,
    },
  )

  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const changeFilter = (val: number | null = null) => {
    setDropdownExpanded(false)
    setFilters({ ticketAssigneeId: val })
  }

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setSearchString(e.target.value)
  }

  return (
    <Dropdown
      className="hidden w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle="Owner"
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!ticketAssigneeId}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <div className="flex w-full px-4">
          <input
            autoComplete="off"
            className="mb-2  w-full rounded border-2 border-border-secondary p-2 focus:outline-none"
            onChange={handleSearch}
            placeholder="Search"
            value={searchString || ''}
          />
        </div>
        <div className="flex w-full">
          {isLoading ? (
            <div className="flex h-24 w-full items-center justify-center">
              <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
            </div>
          ) : (
            <div className="flex max-h-48 min-h-24 w-full overflow-scroll">
              {data && data?.authorizedUsers?.length && (
                <ul>
                  <li
                    className={`${!ticketAssigneeId ? 'selected' : ''}`}
                    onClick={() => changeFilter()}
                    role={'presentation'}
                  >
                    All
                  </li>
                  {data?.authorizedUsers.map((authorizedUser) => (
                    <li key={authorizedUser.id} onClick={() => changeFilter(authorizedUser.id)} role={'presentation'}>
                      {authorizedUser.fullName}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      </FilterOptionsStyled>
    </Dropdown>
  )
}

export const FilterOptionsStyled = styled.div`
  width: 13rem;
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  padding-bottom: 1rem;

  ul {
    width: 100%;
    padding-top: 0.5rem;
    padding-bottom: 0.25rem;
  }
  li {
    margin-bottom: 0.25rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: 100%;
    cursor: pointer;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    line-height: 1;
    &:hover {
      background-color: #f3f3f2;
    }
  }
`
